import api from '../auth';
const slug = 'api/rvps/';

const RvpService = () => {
    const getRvps = () => {
        return api.get(slug).then((res) => res.data);
    };

    const getRvpsLazy = (params) => {
        return api
            .get(slug, {
                params
            })
            .then((res) => res.data);
    };

    const getRvp = (id) => {
        return api.get(slug + `show/${id}/`).then((res) => res.data);
    };

    const deleteRvp = (id) => {
        return api
            .delete(slug + `rvp/${id}/`)
            .then((res) => res.data)
            .catch((err) => {
                return err;
            });
    };

    const createRvp = (data) => {
        return api.post(slug, data).then((res) => res.data);
    };

    const updateRvp = (id, data) => {
        return api.put(slug + `rvp/${id}/`, data).then((res) => res.data);
    };

    const getOptions = () => {
        return api.options(slug).then((res) => res.data.actions.POST);
    };

    // custom action
    const copyRvp = (id) => {
        return api.post(slug + `copy/${id}/`).then((res) => res.data);
    };

    return {
        getRvps,
        getRvpsLazy,
        getRvp,
        deleteRvp,
        createRvp,
        updateRvp,
        getOptions,
        copyRvp
    };
};

export default RvpService;
